"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckCircleIcon = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./CheckCircleIcon.pc.css");
const CheckCircleIcon = ({ small, transparent, className, onClick, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_8ecd7a0c', '_47b2a433', '_pub-47b2a433', '_pub-3c25d522', {
            '_47b2a433_small _pub-47b2a433_small _pub-3c25d522_small small': small,
            '_47b2a433_transparent _pub-47b2a433_transparent _pub-3c25d522_transparent transparent': transparent,
        }, className), onClick: onClick },
        react_1.default.createElement("i", { className: (0, clsx_1.default)('_2c4811c9', '_47b2a433', '_pub-47b2a433', '_pub-3c25d522') })));
};
exports.CheckCircleIcon = CheckCircleIcon;
//# sourceMappingURL=CheckCircleIcon.js.map